import { ReactElement } from 'react';
import { SearchPage } from './search/SearchPage';
import { PaymentDetailPage } from './paymentDetails/PaymentDetailPage';
import { FileDetailPage } from './file_detail/FileDetailPage';

export interface Page {
  path: string;
  title: string;
  content: ReactElement;
  matchExactPath: boolean;
  description?: string;
}

export const searchPage: Page = {
  path: '/',
  title: 'Search',
  content: <SearchPage />,
  matchExactPath: true,
  description: 'Beacon payment search',
};

export const searchAltPage: Page = {
  path: '/search',
  title: 'Search',
  content: <SearchPage />,
  matchExactPath: true,
  description: 'Beacon payment search',
};

export const paymentDetailPage: Page = {
  path: '/payment',
  title: 'Payment Detail',
  content: <PaymentDetailPage />,
  matchExactPath: true,
  description: 'Payment lifecycle detail view',
};

export const fileDetailPage: Page = {
  path: '/file',
  title: 'File',
  content: <FileDetailPage />,
  matchExactPath: true,
  description: 'Beacon file lifecycle and payment count',
};

/**
 * All pages in route order.
 */
export const allPages: Page[] = [
  searchPage,
  searchAltPage,
  paymentDetailPage,
  fileDetailPage,
];
